import {get} from 'lodash';
import template from 'url-template';

import {handleNetworkError, enqueueSnackbar} from './applicationMessageActions';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import * as ActionTypes from './actionTypes';

const AuthorizationRolesUrl = template.parse('/companies/{companyId}/authorization-roles{?searchFilter,limit}');
const CompanyDetailsUrl = template.parse('/companies/{companyId}');
const updateContactUrl = template.parse('/clients/contacts/{contactId}');
const ContractorDataUrl = template.parse('/contractor-types');

const DEFAULT_PAGE_LIMIT = 100;

export const fetchCompanyInfo = (company, options = {}) => async (dispatch, getState) => {

    dispatch({
        type:    ActionTypes.FETCH_BAS_AGENTS,
        payload: []
    });

    const header = await awsHeader();

    const companyId = company.company.id;
    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    let promises = [];

    promises.push(k2aBaseApi.get(
        AuthorizationRolesUrl.expand({
            companyId,
            ...options
        }),
        header
    ));

    promises.push(k2aBaseApi.get(
        CompanyDetailsUrl.expand({
            companyId
        }),
        header
    ));

    promises.push(k2aBaseApi.get(
        ContractorDataUrl.expand(),
        header
    ));
    
    const [roleData, companyDetails, contractorData] = await Promise.all(promises.map(p => p.catch(err => err)));

    const companyInfo = getState().companyInfo;
    const availableContractorTypes = get(contractorData, 'data.data', []);
    const contractorIdsForCompany = companyDetails.data.contractorTypeIds;
    const contractorNamesForCompany = availableContractorTypes.filter(type => contractorIdsForCompany.indexOf(type.id) > -1).map(type => type.name);

    companyInfo.applications = company.applications;
    companyInfo.accentColor = company.company.accentColor;
    companyInfo.billingStatus = company.company.billingStatus;
    companyInfo.billingContact = companyDetails.data.billingContact;
    companyInfo.companyContractorType = contractorNamesForCompany;
    companyInfo.companyName = company.company.name;
    companyInfo.companyId = company.company.id;
    companyInfo.companyAddress = company.company.address.formattedAddress;
    companyInfo.contractorType = contractorNamesForCompany;
    companyInfo.contractorTypes = get(contractorData, 'data.data', []);
    companyInfo.enabled = company.company.enabled;
    companyInfo.hasLogo = company.company.hasLogo;
    companyInfo.scoringEnabled = company.company.scoringEnabled;
    companyInfo.timeZone = company.company.timeZone;
    companyInfo.timeZoneOffset = company.company.timeZoneOffset;


    companyInfo.roles = get(roleData, 'data.data', []).sort((a, b) => _sorter(a, b));

    dispatch({
        type:    ActionTypes.FETCH_COMPANY_INFO,
        payload: companyInfo
    });
};

export const updateContactInfo = (contactId, contactData) => async (dispatch) => {
    const header = await awsHeader();

    try {
        await k2aBaseApi.put(
            updateContactUrl.expand({
                contactId: contactId
            }),
            contactData,
            header
        );

        dispatch(enqueueSnackbar('Contact updated!', 'success'));
        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
};

export const fetchCompanyContractorTypes = () => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const response = await k2aBaseApi.get(
            ContractorDataUrl.expand(),
            header
        );

        const payload = get(response, 'data.data', []);

        dispatch({
            type: ActionTypes.FETCH_CONTRACTOR_TYPES,
            payload
        });

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    }
};

const _sorter = (a, b) => {
    let roleA = a.name.toUpperCase();
    let roleB = b.name.toUpperCase();

    if (roleA < roleB) {
        return -1;
    }
    if (roleA > roleB) {
        return 1;
    }

    return 0;
};

